var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 66,
  height: 66,
  viewBox: "0 0 66 66",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M33 53.5C44.3218 53.5 53.5 44.3218 53.5 33C53.5 21.6782 44.3218 12.5 33 12.5C21.6782 12.5 12.5 21.6782 12.5 33C12.5 44.3218 21.6782 53.5 33 53.5Z",
  fill: "#845EC2"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.9998 25.2988V40.5988",
  stroke: "white",
  strokeWidth: 3,
  strokeMiterlimit: 10
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.5998 32.9988H25.2998",
  stroke: "white",
  strokeWidth: 3,
  strokeMiterlimit: 10
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M65 17.2V1H48.7M17.2 1H1V17.2M1 48.7V65H17.2M48.7 65H65V48.7",
  stroke: "#BDCAD1",
  strokeWidth: 1.5,
  strokeMiterlimit: 10
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plus.bb04841e9143c3da34d8333ea0b3fcca.svg";